import { render } from "./TissuForm.vue?vue&type=template&id=198d4123"
import script from "./TissuForm.vue?vue&type=script&lang=js"
export * from "./TissuForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__